const tagData =[ 'Javascript', 'AJAX', 'REST API', 'GraphQL', 'React', 'Handlebars', 'MongoDB', 'Mongoose', 'Sequelize', 'Express', 'Node', 'Apollo', 'IndexedDB', 'PWA', 'FontAwesome', 'Bootstrap', 'Tailwind CSS', 'PaperCSS', 'SCSS'];

export default tagData; 